var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.325 10.1333C10.925 9.41666 9.10833 8.83333 7 8.83333C4.89167 8.83333 3.075 9.41666 1.675 10.1333C0.841667 10.5583 0.333334 11.4167 0.333334 12.35V14.6667H13.6667V12.35C13.6667 11.4167 13.1583 10.5583 12.325 10.1333ZM12 13H2V12.35C2 12.0333 2.16667 11.75 2.43333 11.6167C3.425 11.1083 5.025 10.5 7 10.5C8.975 10.5 10.575 11.1083 11.5667 11.6167C11.8333 11.75 12 12.0333 12 12.35V13Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C8.84167 8 10.3333 6.50833 10.3333 4.66667C10.3333 3.525 10.3333 1.75 10.3333 1.75C10.3333 1.05833 9.775 0.5 9.08333 0.5C8.65 0.5 8.26667 0.725 8.04167 1.05833C7.81667 0.725 7.43333 0.5 7 0.5C6.56667 0.5 6.18333 0.725 5.95833 1.05833C5.73333 0.725 5.35 0.5 4.91667 0.5C4.225 0.5 3.66667 1.05833 3.66667 1.75C3.66667 1.75 3.66667 3.51667 3.66667 4.66667C3.66667 6.50833 5.15833 8 7 8ZM5.33333 2.58333H8.66667V4.66667C8.66667 5.58333 7.91667 6.33333 7 6.33333C6.08333 6.33333 5.33333 5.58333 5.33333 4.66667V2.58333Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUserIcon);
export default __webpack_public_path__ + "static/media/profile_user_icon.2ba9bee0083de8f1a51df15cbb911d5e.svg";
export { ForwardRef as ReactComponent };